"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.expo = exports.Sol = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const SOL_POWER = new bignumber_js_1.default(Math.pow(10, 9));
const Sol = (num) => new anchor.BN(new bignumber_js_1.default(num).multipliedBy(SOL_POWER).integerValue().toFixed());
exports.Sol = Sol;
const expo = (num, exponent) => new bignumber_js_1.default(num).multipliedBy(Math.pow(10, exponent));
exports.expo = expo;
